import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { PRICING_ROUTES } from "@constants"
import {useUserApp} from "@hooks"
import {USER_ROLES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import PricingMarketAnalyzerFilters from "./Filters"
import {
    PricingMarketAnalyzerTable, PricingMarketAnalyzerSkuEvolution, PricingMarketAnalyzerShareMblChart,
    PricingMarketAnalyzerOffersEvolutionChart, PricingMarketAnalyzerTableSkuDetails , PricingMarketAnalyzerReportFormDrawer
} from "./@components"
import { marketAnalyzerIsEmpty, resetPricingMarket } from "./@signals"
import {isSystemBusy} from "../../../@signals";

const HEIGHT = 200

export default function PricingMarketAnalyzerPage() {

    const { userRole, userUseRRSP} = useUserApp()

    useEffect(() => {
        return () => resetPricingMarket()
    }, [])

    return <PageWrapper
        tourPageKey="marketAnalyzer"
        head={`DIP Insight | ${PRICING_ROUTES.MARKET_ANALYZER_TITLE}`}
        title={PRICING_ROUTES.MARKET_ANALYZER_TITLE}
        subtitle={PRICING_ROUTES.MARKET_ANALYZER_SUBTITLE}
        filters={<PricingMarketAnalyzerFilters />}
        isEmpty={marketAnalyzerIsEmpty.value}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={1}>
            <Grid item xs={12} data-tour="market-analyzer-share-chart">
                {!!userUseRRSP && <PricingMarketAnalyzerShareMblChart
                    sx={{ minHeight: HEIGHT }}
                    title={userRole === USER_ROLES.STANDARD ?
                        'Share Of Same / Low / Above RRSP'
                        : 'Share Of Meet / Beat / Lose'
                }
                />}
            </Grid>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="market-analyzer-table" height={450} />
                <PricingMarketAnalyzerTable />
            </Grid>

            <Grid item xs={12}>
                <PricingMarketAnalyzerSkuEvolution />
            </Grid>

            <Grid item xs={12}>
                <PricingMarketAnalyzerOffersEvolutionChart />
            </Grid>

            <Grid item xs={12}>
                <PricingMarketAnalyzerTableSkuDetails />
            </Grid>

            <Grid item xs={12}>
                <PricingMarketAnalyzerReportFormDrawer />
            </Grid>
        </Grid>
    </PageWrapper>
}
